import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient, getAuthService } from '@edx/frontend-platform/auth';

// eslint-disable-next-line import/prefer-default-export
export async function getThirdPartyAuthContext(urlParams) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    params: urlParams,
    isPublic: true,
  };

  const { data } = await getAuthenticatedHttpClient()
    .get(
      `${getConfig().LMS_BASE_URL}/api/mfe_context`,
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });
  return {
    fieldDescriptions: data.registrationFields || {},
    optionalFields: data.optionalFields || {},
    thirdPartyAuthContext: data.contextData || {},
  };
}

export async function sendActivationEmail() {
  const requestConfig = {
    headers: { 'Content-Type': 'application/json' },
  };

  const authService = getAuthService();

  if (authService) {
    authService.getCsrfTokenService().clearCsrfTokenCache();
    await authService.getCsrfTokenService().getCsrfToken(getConfig().LMS_BASE_URL);
  }

  const { data } = await getAuthenticatedHttpClient()
    .post(`${getConfig().LMS_BASE_URL}/api/send_account_activation_email`, '', requestConfig)
    .catch((e) => {
      throw (e);
    });
  return data;
}
